<template>
    <section class="page-section" v-loading="pageLoading">
                <div class="step-content">
                    <el-form size="small" ref="formData" :model="formData" label-width="150px" class="content-form">
                        <!-- 优惠券类型 -->
                        <div class="form-module" style="margin-top: 0;">
                            <div class="module-header">优惠券类型</div>
                            <div class="module-body">
                                <div class="type-wrap">
                                    <div class="type-item" :class="formData.baseInfo.type == '1' ? 'active' : ''" v-if="!id || formData.baseInfo.type == '1'" @click="handleChangeGoodsType('1')">
                                        <p class="label">现金券</p>
                                        <p class="tips">获得金额固定的优惠券<br />提高店铺销量和客单价</p>
                                    </div>
                                    <div class="type-item" :class="formData.baseInfo.type == '2' ? 'active' : ''" v-if="!id || formData.baseInfo.type == '2'" @click="handleChangeGoodsType('2')">
                                        <p class="label">满减券</p>
                                        <p class="tips">例：满100元减20元<br />便于合理控制活动成本</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- 基本信息 -->
                        <div class="form-module">
                            <div class="module-header">基本信息</div>
                            <div class="module-body">
                                <el-form-item label="优惠券名称" required :show-message="false">
                                    <el-input v-model="formData.baseInfo.name" class="w300" maxlength="50" placeholder="如：新用户专享，不超过10个字" maxLength="10" @change="concatInstructions"></el-input>
                                </el-form-item>
                                <el-form-item label="发放总量">
                                    <el-input v-model="formData.baseInfo.putInLimit" class="w150" maxlength="5" type="number"></el-input>
                                    <span class="unit-text unit-text-right">张</span>
                                    <p class="tips">修改总量时只能增加不能减少，不填写则表示无数量上限，请谨慎设置</p>
                                </el-form-item>
                                <el-form-item label="适用商品" required :show-message="false">
                                    <div class="radio-item">
                                        <div class="radio-icon" :class="[{ 'active': formData.baseInfo.relateType == '1' }]" @click="handleChangeRelateType('1')"></div>
                                        <div class="radio-label">
                                            <div><span>全部商品</span></div>
                                        </div>
                                    </div>
                                    <div class="radio-item">
                                        <div class="radio-icon" :class="[{ 'active': formData.baseInfo.relateType == '2' }]" @click="handleChangeRelateType('2')"></div>
                                        <div class="radio-label">
                                            <div><span>指定商品</span></div>
                                            <div v-if="formData.baseInfo.relateType == '2'">
                                                <div class="flex-h">
                                                    <div class="flex-a-i">
                                                        <el-button type="text" size="small" style="margin-left: 0;" @click="handleRelatedGoodsDialogShow">关联商品</el-button>
                                                    </div>
                                                    <div v-if="commodityList.page.total > 0">
                                                        <el-pagination
                                                            small
                                                            @current-change="handleCommodityListPageChange"
                                                            :current-page="commodityList.page.current"
                                                            :page-size="commodityList.page.size"
                                                            layout="total, prev, pager, next"
                                                            :total="commodityList.page.total">
                                                        </el-pagination>
                                                    </div>
                                                </div>

                                                <el-table size="small" :data="commodityList.tableData" v-loading="commodityList.tableLoading" v-if="commodityList.tableData.length > 0">
                                                    <el-table-column label="商品" width="220">
                                                        <template slot-scope="scope">
                                                            <div class="dialog-goods-title">
                                                                <div class="thumb-wrap">
                                                                    <img :src="scope.row.mainPic">
                                                                </div>
                                                                <p>{{ scope.row.name }}</p>
                                                                <p>¥{{ scope.row.price }}</p>
                                                            </div>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column label="商品类目">
                                                        <template slot-scope="scope">
                                                            <p v-for="(item, index) in scope.row.category" :key="index">{{ item }}</p>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column label="库存" width="80">
                                                        <template slot-scope="scope">
                                                            <p>{{ scope.row.stock }}</p>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column label="总销量" width="60">
                                                        <template slot-scope="scope">
                                                            <p>{{ scope.row.sale || '-' }}</p>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column label="操作" align="right">
                                                        <template slot-scope="scope">
                                                            <el-button size="small" type="text" @click="handleCommodityListRowRemove(scope.row, scope.$index)">移除</el-button>
                                                        </template>
                                                    </el-table-column>
                                                </el-table>
                                            </div>
                                        </div>
                                    </div>
                                </el-form-item>
                                <el-form-item label="使用门槛" required :show-message="false">
                                    <div class="radio-item" :class="id && status != 0 ? 'disabled' : ''" v-if="!(id && status != 0 && formData.baseInfo.thresholdType != '1')">
                                        <div class="radio-icon" :class="[{ 'active': formData.baseInfo.thresholdType == '1' }]" @click="handleChangeThresholdType('1')"></div>
                                        <div class="radio-label">
                                            <div><span>无使用门槛</span></div>
                                        </div>
                                    </div>
                                    <div class="radio-item" :class="id && status != 0 ? 'disabled' : ''" v-if="!(id && status != 0 && formData.baseInfo.thresholdType != '2')">
                                        <div class="radio-icon" :class="[{ 'active': formData.baseInfo.thresholdType == '2' }]" @click="handleChangeThresholdType('2')"></div>
                                        <div class="radio-label">
                                            <div>
                                                <span class="unit-text unit-text-left">订单满</span>
                                                <el-input v-model="formData.baseInfo.thresholdLimit" class="w80" maxlength="8" type="number" @change="concatInstructions" :disabled="!!id && status != 0"></el-input>
                                                <span class="unit-text unit-text-right">元</span>
                                            </div>
                                        </div>
                                    </div>
                                </el-form-item>
                                <el-form-item label="优惠内容" required :show-message="false">
                                    <span class="unit-text unit-text-left" v-if="formData.baseInfo.type == 2">减</span>
                                    <el-input v-model="formData.baseInfo.couponPrice" class="w150" maxlength="6" type="number" @change="concatInstructions" :disabled="!!id && status != 0"></el-input>
                                    <span class="unit-text unit-text-right">元</span>
                                </el-form-item>
                                <el-form-item label="领取时间" v-if="!id || (id && status == 0) || (id && status != 0 && formData.baseInfo.getStartTime && formData.baseInfo.getEndTime)">
                                    <el-date-picker v-model="formData.baseInfo.getStartTime" type="datetime" placeholder="开始时间" class="w185" :disabled="!!id && status != 0"></el-date-picker>
                                    <span class="unit-text unit-text-left unit-text-right">至</span>
                                    <el-date-picker v-model="formData.baseInfo.getEndTime" type="datetime" placeholder="结束时间" class="w185" :disabled="!!id && status != 0"></el-date-picker>
                                </el-form-item>
                                <el-form-item label="用券时间" required :show-message="false">
                                    <div class="radio-item" :class="id && status != 0 ? 'disabled' : ''" v-if="!(id && status != 0 && formData.baseInfo.useType != '1')">
                                        <div class="radio-icon" :class="[{ 'active': formData.baseInfo.useType == '1' }]" @click="handleChangeUseType('1')"></div>
                                        <div class="radio-label">
                                            <div>
                                                <el-date-picker v-model="formData.baseInfo.useStartTime" type="datetime" placeholder="开始时间" class="w185" @change="concatInstructions" :disabled="!!id && status != 0"></el-date-picker>
                                                <span class="unit-text unit-text-left unit-text-right">至</span>
                                                <el-date-picker v-model="formData.baseInfo.useEndTime" type="datetime" placeholder="结束时间" class="w185" @change="concatInstructions" :disabled="!!id && status != 0"></el-date-picker>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="radio-item" :class="id && status != 0 ? 'disabled' : ''" v-if="!(id && status != 0 && formData.baseInfo.useType != '2')">
                                        <div class="radio-icon" :class="[{ 'active': formData.baseInfo.useType == '2' }]" @click="handleChangeUseType('2')"></div>
                                        <div class="radio-label">
                                            <div>
                                                <span class="unit-text unit-text-left">领券当日起</span>
                                                <el-input v-model="formData.baseInfo.useDayLimit" class="w80" maxlength="3" type="number" @change="concatInstructions" :disabled="!!id && status != 0"></el-input>
                                                <span class="unit-text unit-text-right">天内可用</span>
                                                <el-tooltip placement="bottom" popper-class="tips-popover">
                                                    <div slot="content">有效期按自然天计算。<br />举例：如设置领券当日起2天内可用，用户在9月10日14:00时领取优惠券，则该优惠券的可用时间为9月10日的14:00:00至9月11日的23:59:59。</div>
                                                    <i class="el-icon-question" style="font-size: 14px; color: #999; cursor: pointer; margin-left: 5px;"></i>
                                                </el-tooltip>
                                            </div>
                                        </div>
                                    </div>
                                </el-form-item>
                            </div>
                        </div>
                        <!-- 发放和使用规则 -->
                        <div class="form-module">
                            <div class="module-header">发放和使用规则</div>
                            <div class="module-body">
                                <el-form-item label="领取对象" required :show-message="false">
                                    <div class="radio-item">
                                        <div class="radio-icon" :class="[{ 'active': formData.rules.userReceiveType == '1' }]" @click="handleChangeUserReceiveType('1')"></div>
                                        <div class="radio-label">
                                            <div><span>新用户</span></div>
                                        </div>
                                    </div>
                                    <div class="radio-item">
                                        <div class="radio-icon" :class="[{ 'active': formData.rules.userReceiveType == '2' }]" @click="handleChangeUserReceiveType('2')"></div>
                                        <div class="radio-label">
                                            <div><span>老用户</span></div>
                                        </div>
                                    </div>
                                    <div class="radio-item">
                                        <div class="radio-icon" :class="[{ 'active': formData.rules.userReceiveType == '3' }]" @click="handleChangeUserReceiveType('3')"></div>
                                        <div class="radio-label">
                                            <div><span>全部用户</span></div>
                                        </div>
                                    </div>
                                    <div class="radio-item">
                                        <div class="radio-icon" :class="[{ 'active': formData.rules.userReceiveType == '4' }]" @click="handleChangeUserReceiveType('4')"></div>
                                        <div class="radio-label">
                                            <div><span>指定用户</span></div>
                                            <div v-if="formData.rules.userReceiveType == '4'">
                                                <div class="flex-h">
                                                    <div class="flex-a-i">
                                                        <el-button type="text" size="small" style="margin-left: 0;" @click="handleUserDialogShow">关联用户</el-button>
                                                    </div>
                                                    <div v-if="userList.page.total > 0">
                                                        <el-pagination
                                                            small
                                                            @current-change="handleUserListPageChange"
                                                            :current-page="userList.page.current"
                                                            :page-size="userList.page.size"
                                                            layout="total, prev, pager, next"
                                                            :total="userList.page.total">
                                                        </el-pagination>
                                                    </div>
                                                </div>

                                                <el-table size="small" :data="userList.tableData" v-loading="userList.tableLoading" v-if="formData.rules.userIds.length > 0">
                                                    <el-table-column label="昵称">
                                                        <template slot-scope="scope">
                                                            <p>{{ scope.row.name }}</p>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column label="手机号">
                                                        <template slot-scope="scope">
                                                            <p>{{ scope.row.mobile }}</p>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column label="来源">
                                                        <template slot-scope="scope">
                                                            <p v-if="scope.row.type == 1">主动注册</p>
                                                            <p v-if="scope.row.type == 2">h5用户</p>
                                                            <p v-if="scope.row.type == 3">和聊用户</p>
                                                            <p v-if="scope.row.type == 4">小程序用户</p>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column label="首次登陆时间">
                                                        <template slot-scope="scope">
                                                            <p>{{ scope.row.firstLoginTime }}</p>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column label="购买次数">
                                                        <template slot-scope="scope">
                                                            <p>{{ scope.row.buyTimes }}</p>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column label="上次购买时间">
                                                        <template slot-scope="scope">
                                                            <p>{{ scope.row.lastBuyTime || '-' }}</p>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column label="操作" align="right">
                                                        <template slot-scope="scope">
                                                            <el-button size="small" type="text" @click="handleUserListRowRemove(scope.row, scope.$index)">移除</el-button>
                                                        </template>
                                                    </el-table-column>
                                                </el-table>
                                            </div>
                                        </div>
                                    </div>
                                </el-form-item>
                                <el-form-item label="发放方式" required :show-message="false">
                                    <div class="radio-item" :class="id && status != 0 ? 'disabled' : ''" v-if="!(id && status != 0 && formData.rules.provideType != '1')">
                                        <div class="radio-icon" :class="[{ 'active': formData.rules.provideType == '1' }]" @click="handleChangeProvideType('1')"></div>
                                        <div class="radio-label">
                                            <div><span>系统发放</span></div>
                                        </div>
                                    </div>
                                    <div class="radio-item" :class="id && status != 0 ? 'disabled' : ''" v-if="!(id && status != 0 && formData.rules.provideType != '2')">
                                        <div class="radio-icon" :class="[{ 'active': formData.rules.provideType == '2' }]" @click="handleChangeProvideType('2')"></div>
                                        <div class="radio-label">
                                            <div><span>用户领取</span></div>
                                        </div>
                                    </div>
                                </el-form-item>
                                <el-form-item label="限领次数" required :show-message="false">
                                    <div class="radio-item" :class="id && status != 0 ? 'disabled' : ''" v-if="!(id && status != 0 && formData.rules.userNumType != '1')">
                                        <div class="radio-icon" :class="[{ 'active': formData.rules.userNumType == '1' }]" @click="handleChangeUserNumType('1')"></div>
                                        <div class="radio-label">
                                            <div><span>不限次数</span></div>
                                        </div>
                                    </div>
                                    <div class="radio-item" :class="id && status != 0 ? 'disabled' : ''" v-if="!(id && status != 0 && formData.rules.userNumType != '2')">
                                        <div class="radio-icon" :class="[{ 'active': formData.rules.userNumType == '2' }]" @click="handleChangeUserNumType('2')"></div>
                                        <div class="radio-label">
                                            <div>
                                                <span class="unit-text unit-text-left">每个ID限领</span>
                                                <el-input v-model="formData.rules.userNumLimit" class="w80" maxlength="8" type="number" :disabled="!!id && status != 0"></el-input>
                                                <span class="unit-text unit-text-right">次</span>
                                            </div>
                                            <div><span class="tips">限领次数仅对用户主动领取时生效</span></div>
                                        </div>
                                    </div>
                                </el-form-item>
                                <el-form-item label="使用限制" required :show-message="false">
                                    <div class="radio-item" :class="id && status != 0 ? 'disabled' : ''" v-if="!(id && status != 0 && formData.rules.useLimitType != '1')">
                                        <div class="radio-icon" :class="[{ 'active': formData.rules.useLimitType == '1' }]" @click="handleChangeUseLimitType('1')"></div>
                                        <div class="radio-label">
                                            <div><span>可叠加使用</span></div>
                                        </div>
                                    </div>
                                    <div class="radio-item" :class="id && status != 0 ? 'disabled' : ''" v-if="!(id && status != 0 && formData.rules.useLimitType != '2')">
                                        <div class="radio-icon" :class="[{ 'active': formData.rules.useLimitType == '2' }]" @click="handleChangeUseLimitType('2')"></div>
                                        <div class="radio-label">
                                            <div><span>不可叠加使用</span></div>
                                        </div>
                                    </div>
                                </el-form-item>
                                <!-- <el-form-item label="转赠设置">
                                    <div class="checkbox-item" :class="id && status != 0 ? 'disabled' : ''">
                                        <div class="checkbox-icon" :class="[{ 'active': formData.rules.canGive == '1' }]" @click="handleToggleCanGive"></div>
                                        <div class="checkbox-label">
                                            <div><span>优惠券允许转赠给好友</span></div>
                                        </div>
                                    </div>
                                </el-form-item> -->
                                <el-form-item label="使用说明">
                                    <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="formData.rules.instructions" class="w300" resize="none" @focus="handleInstructionsFocus" @blur="handleInstructionsBlur"></el-input>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="form-button-wrap">
                            <el-button type="default" size="small" @click="handleFormdataSubmitCancel">取消</el-button>
                            <el-button type="primary" size="small" :loading="formData.submitLoading" @click="handleFormdataSubmitEnsure">保存</el-button>
                        </div>
                    </el-form>
                </div>
            

        <!-- 关联商品 弹窗 -->
        <DialogGoods :ids="commodityList.ids" ref="goodsRelate" @ids="getRelatedGoodsIds"></DialogGoods>

        <!-- 指定用户 弹窗 -->
        <el-dialog title="选择用户" :visible.sync="userDialog.visible" custom-class="dialog-table-select">
            <!-- filter -->
            <div class="filter">
                <el-form size="small" :inline="true" :model="userDialog.filterForm" ref="userDialogFilterForm" class="filter-form">
                    <el-form-item label="" prop="type" style="margin-right: 10px;">
                        <el-select v-model="userDialog.filterForm.type" placeholder="">
                            <el-option label="全部" value="0"></el-option>
                            <el-option label="主动注册" value="1"></el-option>
                            <el-option label="h5用户" value="2"></el-option>
                            <el-option label="和聊用户" value="3"></el-option>
                            <el-option label="小程序用户" value="4"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="" prop="content" class="auto-width">
                        <el-input v-model="userDialog.filterForm.content" placeholder="输入用户昵称或手机号"><i slot="prefix" class="el-input__icon el-icon-search"></i></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="userDialogFilterFormSubmit('userDialogFilterForm')" :loading="userDialog.tableLoading">查询</el-button>
                        <el-button type="default" plain @click="userDialogFilterFormReset('userDialogFilterForm')">重置</el-button>
                    </el-form-item>
                </el-form>
            </div>

            <!-- table -->
            <div class="table-region" v-loading="userDialog.tableLoading">
                <el-table size="small" :data="userDialog.tableData" ref="userDialogMultipleTable" @select="handleUserDialogTableSelectionRowToggle" @select-all="handleUserDialogTableSelectionAllToggle">
                    <el-table-column type="selection" width="42"></el-table-column>
                    <el-table-column label="昵称">
                        <template slot-scope="scope">
                            <p>{{ scope.row.name }}</p>
                        </template>
                    </el-table-column>
                    <el-table-column label="手机号">
                        <template slot-scope="scope">
                            <p>{{ scope.row.mobile }}</p>
                        </template>
                    </el-table-column>
                    <el-table-column label="来源">
                        <template slot-scope="scope">
                            <p v-if="scope.row.type == 1">主动注册</p>
                            <p v-if="scope.row.type == 2">h5用户</p>
                            <p v-if="scope.row.type == 3">和聊用户</p>
                            <p v-if="scope.row.type == 4">小程序用户</p>
                        </template>
                    </el-table-column>
                    <el-table-column label="首次登陆时间">
                        <template slot-scope="scope">
                            <p>{{ scope.row.firstLoginTime }}</p>
                        </template>
                    </el-table-column>
                    <el-table-column label="购买次数">
                        <template slot-scope="scope">
                            <p>{{ scope.row.buyTimes }}</p>
                        </template>
                    </el-table-column>
                    <el-table-column label="上次购买时间">
                        <template slot-scope="scope">
                            <p>{{ scope.row.lastBuyTime || '-' }}</p>
                        </template>
                    </el-table-column>
                </el-table>

                <div class="table-footer" v-if="userDialog.page.total > 0">
                    <div class="selection-operate"></div>

                    <div class="pagination-wrap">
                        <el-pagination
                            @current-change="handleUserDialogCurrentChange"
                            :page-sizes="[20, 50, 100]"
                            :current-page="userDialog.page.current"
                            :page-size="userDialog.page.size"
                            layout="total, prev, pager, next, jumper"
                            :total="userDialog.page.total">
                        </el-pagination>
                    </div>
                </div>
            </div>

            <span slot="footer" class="dialog-footer">
                <p class="selected-total">已选 <span class="color-red">{{ userDialog.multipleSelection.length }}</span></p>
                <el-button size="small" plain @click="userDialog.visible = false">取 消</el-button>
                <el-button size="small" type="primary" @click="handleUserDialogSelectionEnsure">确 定</el-button>
            </span>
        </el-dialog>
      </section>
</template>
<script>
    import { BASE, COMMON, couponSaveUpdate, couponEditDetail, userUserList, commodityFilterList } from '@/common/api'
    import DialogGoods from '@/components/dialog/goods.vue'

    export default {
        name: 'marketingCouponAdd',
        data() {
            return {
                id: this.$route.query.id || '',
                status: '',
                pageLoading: true,

                formData: { // 表单数据
                    baseInfo: {
                        type: '1', // 1: 现金券 2: 满减券
                        name: '', // 优惠券名称
                        putInLimit: '', // 发放总量
                        relateType: '', // 商品关联类型
                        commodityIds: [], // 关联的商品列表
                        thresholdType: '', // 1: 无门槛 2: 有门槛
                        thresholdLimit: '', // 门槛金额
                        couponPrice: '', // 优惠金额
                        getStartTime: '', // 领取开始时间
                        getEndTime: '', // 领取结束时间
                        useType: '', // 1: 固定时间 2: 领券内几天
                        useStartTime: '', // 用券开始时间
                        useEndTime: '', // 用券结束时间
                        useDayLimit: '' // 领券内几天使用的天数限制
                    },
                    rules: {
                        userReceiveType: '', // 1: 新用户 2: 老用户 3: 全部用户 4: 指定用户
                        userIds: [], // 指定用户id列表
                        provideType: '', // 1: 系统发放 2: 用户领取
                        userNumType: '', // 1: 不限次数 2: 限制领取
                        userNumLimit: '', // 限制用户领取数量
                        useLimitType: '', // 1: 可叠加使用 2: 不可叠加使用
                        canGive: '', // 0: 不允许 1: 允许
                        instructions: '' // 使用说明
                    },
                    submitLoading: false,
                    edited: false
                },

                commodityList: { // 选中的指定商品
                    ids: [],
                    tableLoading: false,
                    tableData: [],
                    page: {
                        current: 1,
                        size: 5,
                        total: 0
                    }
                },

                userList: { // 选中的指定用户
                    tableLoading: false,
                    tableData: [],
                    page: {
                        current: 1,
                        size: 5,
                        total: 0
                    }
                },

                userDialog: { // 指定用户 弹窗
                    visible: false,

                    filterForm: {
                        type: '0',
                        content: ''
                    },

                    tableLoading: true,
                    tableData: [], //表格数据
                    page: {
                        current: 1,
                        size: 5,
                        total: 0 
                    },

                    multipleSelection: [] // 选中的数据
                }
            }
        },
        components: {
            DialogGoods
        },
        watch: {

        },
        methods: {
            getDetail: function() {
                if(!this.id) {
                    this.pageLoading = false;
                    return false;
                }

                this.pageLoading = true;

                let params = {
                    id: this.id
                }

                couponEditDetail(params).then(res => {
                    let { code, data, msg } = res;

                    if(code == 0) {
                        this.pageLoading = false;

                        this.status = data.status;

                        let baseInfo = {},
                            rules = {};

                        baseInfo.name = data.name;
                        baseInfo.type = data.type;
                        baseInfo.putInLimit = data.putInLimit;
                        baseInfo.relateType = data.relateType;
                        baseInfo.commodityIds = data.commodityIds || [];
                        baseInfo.thresholdType = data.thresholdType;
                        baseInfo.thresholdLimit = data.thresholdLimit;
                        baseInfo.couponPrice = data.couponPrice;
                        baseInfo.getStartTime = data.getStartTime;
                        baseInfo.getEndTime = data.getEndTime;
                        baseInfo.useType = data.useType;
                        baseInfo.useDayLimit = data.useDayLimit;
                        baseInfo.useStartTime = data.useStartTime;
                        baseInfo.useEndTime = data.useEndTime;


                        rules.userReceiveType = data.userReceiveType;
                        rules.userIds = data.userIds || [];
                        rules.provideType = data.provideType;
                        rules.userNumType = data.userNumType;
                        rules.userNumLimit = data.userNumLimit;
                        rules.useLimitType = data.useLimitType;
                        rules.canGive = data.canGive;
                        rules.instructions = data.instructions;

                        this.formData.baseInfo = baseInfo;
                        this.formData.rules = rules;

                        this.handleGetRelatedGoodsList();

                        this.userDialog.multipleSelection = JSON.parse(JSON.stringify(rules.userIds));
                        this.handleUserSelectionList();
                    } else {
                        this.$message.error(msg);
                    }
                }).catch(error => {
                    this.$message.error('服务器异常');
                });
            },
            /**
             * [handleChangeGoodsType description] 切换优惠券类型
             * @param  {[type]} type [description]
             * @return {[type]}      [description]
             */
            handleChangeGoodsType: function (type) {
                let goodsType = this.formData.baseInfo.type;

                if (goodsType == type) {
                    return false;
                }

                this.formData.baseInfo.type = type;
            },
            /**
             * [handleChangeRelateType description] 切换适用商品类型
             * @param  {[type]} type [description]
             * @return {[type]}      [description]
             */
            handleChangeRelateType: function (type) {
                let relateType = this.formData.baseInfo.relateType;

                if (relateType == type) {
                    return false;
                }

                this.formData.baseInfo.relateType = type;

                this.concatInstructions();
            },
            /**
             * [handleChangeThresholdType description] 切换门槛类型
             * @param  {[type]} type [description]
             * @return {[type]}      [description]
             */
            handleChangeThresholdType: function (type) {
                let thresholdType = this.formData.baseInfo.thresholdType;

                if (thresholdType == type) {
                    return false;
                }

                this.formData.baseInfo.thresholdType = type;

                this.concatInstructions();
            },
            /**
             * [handleChangeUseType description] 切换用券类型
             * @param  {[type]} type [description]
             * @return {[type]}      [description]
             */
            handleChangeUseType: function (type) {
                let useType = this.formData.baseInfo.useType;

                if (useType == type) {
                    return false;
                }

                this.formData.baseInfo.useType = type;

                this.concatInstructions();
            },
            /**
             * [handleChangeUserReceiveType description] 切换用户领取类型
             * @param  {[type]} type [description]
             * @return {[type]}      [description]
             */
            handleChangeUserReceiveType: function (type) {
                let userReceiveType = this.formData.rules.userReceiveType;

                if (userReceiveType == type) {
                    return false;
                }

                this.formData.rules.userReceiveType = type;

                this.concatInstructions();
            },
            /**
             * [handleChangeProvideType description] 切换领取方式
             * @param  {[type]} type [description]
             * @return {[type]}      [description]
             */
            handleChangeProvideType: function (type) {
                let provideType = this.formData.rules.provideType;

                if (provideType == type) {
                    return false;
                }

                this.formData.rules.provideType = type;
            },
            /**
             * [handleChangeUserNumType description] 切换领取次数
             * @param  {[type]} type [description]
             * @return {[type]}      [description]
             */
            handleChangeUserNumType: function (type) {
                let userNumType = this.formData.rules.userNumType;

                if (userNumType == type) {
                    return false;
                }

                this.formData.rules.userNumType = type;

                if(type == '2') {
                    this.formData.rules.userNumLimit = 1;
                }
            },
            /**
             * [handleChangeUseLimitType description] 切换使用限制
             * @param  {[type]} type [description]
             * @return {[type]}      [description]
             */
            handleChangeUseLimitType: function (type) {
                let useLimitType = this.formData.rules.useLimitType;

                if (useLimitType == type) {
                    return false;
                }

                this.formData.rules.useLimitType = type;

                this.concatInstructions();
            },
            /**
             * [handleToggleCanGive description] 转赠设置
             * @return {[type]} [description]
             */
            handleToggleCanGive: function() {
                if(this.id && this.status != 0) {
                    return false;
                }

                let canGive = this.formData.rules.canGive;

                if(canGive == '1') {
                    this.formData.rules.canGive = 0;
                } else {
                    this.formData.rules.canGive = 1;
                }
            },
            /**
             * [handleInstructionsFocus description] 说明内容聚焦
             * @return {[type]} [description]
             */
            handleInstructionsFocus: function() {
                this.copy = this.formData.rules.instructions;
            },
            /**
             * [handleInstructionsBlur description] 说明内容失焦
             * @return {[type]} [description]
             */
            handleInstructionsBlur: function() {
                if(this.copy != this.formData.rules.instructions) {
                    this.formData.edited = true;
                }
            },
            /**
             * [concatInstructions description] 拼装说明内容
             * @return {[type]} [description]
             */
            concatInstructions: function() {
                if(this.formData.edited) {
                    // 管理员已编辑过详情
                    return false;
                }

                let useTime = '',
                    prod = '',
                    limit = '',
                    cutPrice = '',
                    useSet = '';

                if(this.formData.baseInfo.useType == 1) {
                    if(this.formData.baseInfo.useStartTime && this.formData.baseInfo.useEndTime) {
                        useTime = COMMON.formatDate('2', '-', this.formData.baseInfo.useStartTime) + '-' + COMMON.formatDate('2', '-', this.formData.baseInfo.useEndTime);
                    }
                } else if(this.formData.baseInfo.useType == 2) {
                    useTime = '领券当日起'+ this.formData.baseInfo.useDayLimit +'天内可用';
                }

                if(this.formData.baseInfo.relateType == 1) {
                    prod = '全部商品';
                } else if(this.formData.baseInfo.relateType == 2) {
                    prod = '部分商品--指定商品和活动商品';
                }

                if(this.formData.baseInfo.thresholdType == 1) {
                    limit = '无门槛';
                } else if(this.formData.baseInfo.thresholdType == 2) {
                    if(this.formData.baseInfo.thresholdLimit) {
                        limit = '满'+ this.formData.baseInfo.thresholdLimit +'元';
                    }
                }

                if(this.formData.baseInfo.couponPrice) {
                    cutPrice = '减免'+ this.formData.baseInfo.couponPrice +'元'
                }

                if(this.formData.rules.useLimitType == 1) {
                    useSet = '可叠加使用';
                } else if(this.formData.rules.useLimitType == 2) {
                    useSet = '不可叠加使用';
                }



                this.formData.rules.instructions = this.formData.baseInfo.name + '\n使用时间：'+ useTime +'，\n优惠内容：可用商品（'+ prod +'），使用门槛（'+ limit +'），优惠内容（'+ cutPrice +'），使用设置（'+ useSet +'）';
            },
            /**
             * [handleFormdataSubmitCancel description] 取消
             * @return {[type]} [description]
             */
            handleFormdataSubmitCancel: function() {
                this.$router.push({ path: '/marketing/coupon/list' });
            },
            /**
             * [handleFormdataSubmitEnsure description] 保存
             * @return {[type]} [description]
             */
            handleFormdataSubmitEnsure: function() {
                if(!this.validateSubmitData()) {
                    return false;
                }

                let baseInfo = this.formData.baseInfo,
                    rules = this.formData.rules;

                let params = {
                    id: this.id,
                    name: baseInfo.name,
                    type: baseInfo.type,
                    putInLimit: baseInfo.putInLimit,
                    relateType: baseInfo.relateType,
                    commodityIds: baseInfo.relateType == '1' ? [] : baseInfo.commodityIds,
                    thresholdType: baseInfo.thresholdType,
                    thresholdLimit: baseInfo.thresholdType == '' ? '' : baseInfo.thresholdLimit,
                    couponPrice: baseInfo.couponPrice,
                    getStartTime: baseInfo.getStartTime && baseInfo.getEndTime ? COMMON.formatDate('2', '-', baseInfo.getStartTime) : '',
                    getEndTime:  baseInfo.getStartTime && baseInfo.getEndTime ? COMMON.formatDate('2', '-', baseInfo.getEndTime) : '',
                    useType: baseInfo.useType,
                    useDayLimit: baseInfo.useType == '2' ? baseInfo.useDayLimit : '',
                    useStartTime: baseInfo.useType == '1' ? COMMON.formatDate('2', '-', baseInfo.useStartTime) : '',
                    useEndTime: baseInfo.useType == '1' ? COMMON.formatDate('2', '-', baseInfo.useEndTime) : '',
                    userReceiveType: rules.userReceiveType,
                    userIds: rules.userReceiveType == '4' ? rules.userIds : [],
                    provideType: rules.provideType,
                    userNumType: rules.userNumType,
                    userNumLimit: rules.userNumType == '2' ? rules.userNumLimit : '',
                    useLimitType: rules.useLimitType,
                    canGive: rules.canGive || 0,
                    instructions: rules.instructions
                }

                this.formData.submitLoading = true;

                couponSaveUpdate(params).then(res => {
                    this.formData.submitLoading = false;

                    let { code, data, msg } = res;

                    if(code == 0) {
                        this.$message({ message: '保存优惠券成功', type: 'success' });

                        this.handleFormdataSubmitCancel();
                    } else {
                        this.$message.error(msg);
                    }
                }).catch(error => {
                    this.formData.submitLoading = false;
                    this.$message.error('服务器异常');
                });
            },
            /**
             * [validateSubmitData description] 校验表单数据
             * @return {[type]} [description]
             */
            validateSubmitData: function() {
                let baseInfo = this.formData.baseInfo,
                    rules = this.formData.rules;

                // ----------------------------------------
                if(!baseInfo.name) {
                    this.$message.error('请输入优惠券名称');
                    return false;
                }

                // ----------------------------------------
                if(!baseInfo.relateType) {
                    this.$message.error('请选择适用商品');
                    return false;
                }
                
                if(baseInfo.relateType == '2' && baseInfo.commodityIds.length == 0) {
                    this.$message.error('请添加指定商品');
                    return false;
                }

                // ----------------------------------------
                if(!baseInfo.thresholdType) {
                    this.$message.error('请选择使用门槛');
                    return false;
                }
                if(baseInfo.thresholdType == 2 && !baseInfo.thresholdLimit) {
                    this.$message.error('请输入订单金额');
                    return false;
                }

                if(!baseInfo.couponPrice) {
                    this.$message.error('请输入优惠内容');
                    return false;
                }
                
                // ----------------------------------------
                if(!baseInfo.useType) {
                    this.$message.error('请选择用券时间');
                    return false;
                }
                if(baseInfo.useType == '1' && !baseInfo.useStartTime) {
                    this.$message.error('请选择用券开始时间');
                    return false;
                }
                if(baseInfo.useType == '1' && !baseInfo.useEndTime) {
                    this.$message.error('请选择用券结束时间');
                    return false;
                }
                if(baseInfo.useType == '2' && !baseInfo.useDayLimit) {
                    this.$message.error('请输入领券当日起几天可用');
                    return false;
                }

                // ----------------------------------------
                if(!rules.userReceiveType) {
                    this.$message.error('请选择领取对象');
                    return false;
                }
                if(rules.userReceiveType == '4' && rules.userIds.length == 0) {
                    this.$message.error('请选择指定用户');
                    return false;
                }

                // ----------------------------------------
                if(!rules.provideType) {
                    this.$message.error('请选择发放方式');
                    return false;
                }

                // ----------------------------------------
                if(!rules.userNumType) {
                    this.$message.error('请选择限领次数');
                    return false;
                }
                if(rules.userNumType == '2' && !rules.userNumLimit) {
                    this.$message.error('请输入每个ID限领次数');
                    return false;
                }

                // ----------------------------------------
                if(!rules.useLimitType) {
                    this.$message.error('请选择使用限制');
                    return false;
                }

                return true;
            },

            // ==============================================================================================================================
            // ==============================================================================================================================
            // ==============================================================================================================================
            /**
             * [handleRelatedGoodsDialogShow description] 指定商品 - 弹窗 - 显示
             * @return {[type]} [description]
             */
            handleRelatedGoodsDialogShow: function() {
                this.commodityList.ids = JSON.parse(JSON.stringify(this.formData.baseInfo.commodityIds));
                this.$refs.goodsRelate.handleDialogShow();
            },
            /**
             * [getRelatedGoodsIds description] 指定商品 - 弹窗 - 选中的数据id集合
             * @param  {[type]} ids [description]
             * @return {[type]}     [description]
             */
            getRelatedGoodsIds: function(ids) {
                this.formData.baseInfo.commodityIds = ids;
                this.handleGetRelatedGoodsList();
            },
            /**
             * [handleGetRelatedGoodsList description] 指定商品 - 根据选中数据的id集合获取商品列表
             * @return {[type]} [description]
             */
            handleGetRelatedGoodsList: function() {
                this.commodityList.tableLoading = true;

                let params = {
                    idStr: this.formData.baseInfo.commodityIds.join(','),
                    current: this.commodityList.page.current,
                    size: this.commodityList.page.size
                }

                commodityFilterList(params).then(res =>{
                    this.commodityList.tableLoading = false;

                    let { code, data, msg } = res;

                    if(code == 0) {
                        let dataArray = data.records || [];

                        this.commodityList.tableData = dataArray;
                        this.commodityList.page.total = data.total;
                    } else {
                        this.$message.error(msg);
                    }
                }).catch(error => {
                    this.$message.error('服务器异常');
                });
            },
            /**
             * [handleCommodityListPageChange description] 指定商品 - 列表 - 切换分页
             * @param  {[type]} val [description]
             * @return {[type]}     [description]
             */
            handleCommodityListPageChange: function(val) {
                this.commodityList.page.current = val;
                this.handleGetRelatedGoodsList();
            },
            /**
             * [handleCommodityListRowRemove description] 指定商品 - 列表 - 移除
             * @param  {[type]} row   [description]
             * @param  {[type]} index [description]
             * @return {[type]}       [description]
             */
            handleCommodityListRowRemove: function(row, index) {
                let tableData = this.commodityList.tableData,
                    ids = this.formData.baseInfo.commodityIds;

                tableData.splice(index, 1);
                ids.splice(ids.indexOf(row.id), 1);
                this.commodityList.page.total -= 1;
                if(this.commodityList.page.current > 1 && tableData.length == 0) {
                    this.commodityList.page.current = 1
                    this.handleGetRelatedGoodsList();
                }
            },

            // ==============================================================================================================================
            // ==============================================================================================================================
            // ==============================================================================================================================

            /**
             * [handleUserDialogShow description] 指定用户 - 弹窗 - 显示
             * @return {[type]} [description]
             */
            handleUserDialogShow: function() {
                this.userDialog.visible = true;
                this.userDialog.filterForm.type = '0';
                this.userDialog.filterForm.content = '';
                this.userDialog.page.current = 1;
                this.userDialog.tableData = [];

                this.userDialogGetUserList();
            },
            /**
             * [userDialogFilterFormSubmit description] 指定用户 - 弹窗 - 提交筛选表单
             * @param  {[type]} formName [description]
             * @return {[type]}          [description]
             */
            userDialogFilterFormSubmit: function(formName) {
                this.userDialog.page.current = 1;

                this.userDialogGetUserList();
            },
            /**
             * [userDialogFilterFormReset description] 指定用户 - 弹窗 - 重置筛选表单
             * @param  {[type]} formName [description]
             * @return {[type]}          [description]
             */
            userDialogFilterFormReset: function(formName) {
                this.$refs[formName].resetFields();
            },
            /**
             * [userDialogGetUserList description] 指定用户 - 弹窗 - 获取用户列表
             * @return {[type]} [description]
             */
            userDialogGetUserList: function() {
                this.userDialog.tableLoading = true;

                let params = {
                    type: this.userDialog.filterForm.type,
                    content: this.userDialog.filterForm.content,
                    current: this.userDialog.page.current,
                    size: this.userDialog.page.size
                }

                userUserList(params).then(res =>{
                    this.userDialog.tableLoading = false;

                    let { code, data, msg } = res;

                    if(code == 0) {
                        let dataArray = data.records || [];

                        this.userDialog.tableData = dataArray;
                        this.userDialog.page.total = data.total;

                        this.$nextTick(() => {
                            if(dataArray.length > 0) {
                                let userIds = this.userDialog.multipleSelection;

                                for(let i = 0; i < dataArray.length; i++) {
                                    if(userIds.indexOf(dataArray[i].id) > -1) {
                                        this.$refs.userDialogMultipleTable.toggleRowSelection(dataArray[i], true);
                                    }
                                }
                            }
                        })
                    } else {
                        this.$message.error(msg);
                    }
                }).catch(error => {
                    this.$message.error('服务器异常');
                });
            },
            /**
             * [handleUserDialogCurrentChange description]  指定用户 - 弹窗 - 选择分页第几页
             * @param  {[type]} val [description]
             * @return {[type]}     [description]
             */
            handleUserDialogCurrentChange(val) {
                this.userDialog.page.current = val;
                this.userDialogGetUserList();
            },
            /**
             * [handleUserDialogTableSelectionRowToggle description] 指定用户 - 弹窗 - table单行 - 选中状态变化
             * @param  {[type]} selection [description]
             * @param  {[type]} row       [description]
             * @return {[type]}           [description]
             */
            handleUserDialogTableSelectionRowToggle: function(selection, row) {
                let userIds = this.userDialog.multipleSelection;

                if(selection.length > 0) {
                    for(let i = 0; i < selection.length; i++) {
                        if(selection[i].id == row.id) {
                            userIds.push(row.id);
                            break;
                        }

                        if(i == selection.length - 1) {
                            userIds.splice(userIds.indexOf(row.id), 1);
                        }
                    }
                } else {
                    userIds.splice(userIds.indexOf(row.id), 1);
                }

                this.userDialog.multipleSelection = Array.from(new Set(userIds));
            },
            /**
             * [handleUserDialogTableSelectionAllToggle description]  指定用户 - 弹窗 - table全部 - 选中状态变化
             * @param  {[type]} val [description] 选中行的数据集合array
             * @return {[type]}     [description]
             */
            handleUserDialogTableSelectionAllToggle: function(val) {
                let userIds = this.userDialog.multipleSelection;

                if(val.length > 0) {
                    for(let i = 0; i < val.length; i++) {
                        let valItem = val[i],
                            index = userIds.indexOf(valItem.id);
                        
                        if(index == -1) {
                            userIds.push(valItem.id)
                        }
                    }
                } else {
                    let tableData = this.userDialog.tableData;

                    if(tableData.length > 0) {
                        for(let i = 0; i < tableData.length; i++) {
                            let index = userIds.indexOf(tableData[i].id);

                            if(index > -1) {
                                userIds.splice(index, 1);
                            }
                        }
                    }
                }

                this.userDialog.multipleSelection = Array.from(new Set(userIds));
            },
            /**
             * [handleUserDialogSelectionEnsure description]  指定用户 - 弹窗 - 确定选中 - 选中数据的id集合
             * @return {[type]} [description]
             */
            handleUserDialogSelectionEnsure: function() {
                this.formData.rules.userIds = this.userDialog.multipleSelection;
                this.userDialog.visible = false;

                this.handleUserSelectionList();
            },
            /**
             * [handleUserSelectionList description] 指定用户 - 根据选中数据的id集合获取用户列表
             * @return {[type]} [description]
             */
            handleUserSelectionList: function() {
                this.userList.tableLoading = true;

                let params = {
                    idStr: this.formData.rules.userIds.join(','),
                    current: this.userList.page.current,
                    size: this.userList.page.size
                }

                userUserList(params).then(res =>{
                    this.userList.tableLoading = false;

                    let { code, data, msg } = res;

                    if(code == 0) {
                        let dataArray = data.records || [];

                        this.userList.tableData = dataArray;
                        this.userList.page.total = data.total;
                    } else {
                        this.$message.error(msg);
                    }
                }).catch(error => {
                    this.$message.error('服务器异常');
                });
            },
            /**
             * [handleUserListPageChange description] 指定用户 - 列表 - 切换分页
             * @param  {[type]} val [description]
             * @return {[type]}     [description]
             */
            handleUserListPageChange: function(val) {
                this.userList.page.current = val;
                this.handleUserSelectionList();
            },
            /**
             * [handleUserListRowRemove description] 指定用户 - 列表 - 移除
             * @param  {[type]} row   [description]
             * @param  {[type]} index [description]
             * @return {[type]}       [description]
             */
            handleUserListRowRemove: function(row, index) {
                let tableData = this.userList.tableData,
                    ids = this.formData.rules.userIds;

                tableData.splice(index, 1);
                ids.splice(ids.indexOf(row.id), 1);
                this.userList.page.total -= 1;
                if(this.userList.page.current > 1 && tableData.length == 0) {
                    this.userList.page.current = 1
                    this.handleUserSelectionList();
                }
            }
        },
        mounted() {
            this.getDetail();
        }
    }

</script>
<style lang="scss" scoped>
    @import "../../../common/styles/base/mixin-font";
    @import "../../../common/styles/base/mixin-common";

    .type-wrap {
        font-size: 0;
        text-align: left;

        .type-item {
            position: relative;
            display: inline-block;
            margin-left: 80px;
            padding: 10px 20px;
            border: 1px solid #DDDDDD;
            border-radius: 2px;
            cursor: pointer;

            &+.type-item {
                margin-left: 10px;
            }

            .label {
                font-size: 12px;
                line-height: 17px;
                color: #222;
                text-align: center;
            }

            .tips {
                margin-top: 4px;
                font-size: 12px;
                line-height: 17px;
                color: rgba(#222, .5);
            }

            &.active {
                border-color: $themeColor;

                .label {
                    color: $themeColor;
                }

                &::before {
                    content: "";
                    @include position(absolute, 3, 0, 0, none, none);
                    width: 16px;
                    height: 16px;
                    @include backgroundImage('../../../assets/icon_16_2@2x.png', no-repeat, right, center, auto, 16px);
                }
            }
        }
    }

    .unit-text {
        font-size: $smallFS;
        color: $textColor;

        &.unit-text-right {
            margin-left: 10px;
        }

        &.unit-text-left {
            margin-right: 10px;
        }
    }

    .grey-inline-block {
        display: inline-block;
        background: $colorPageBg;
    }

    .radio-item {
        position: relative;
        padding-left: 26px;

        &+.radio-item {
            margin-top: 10px;
        }

        .radio-icon {
            @include position(absolute, 1, 8px, none, none, 0);
            width: 16px;
            height: 16px;
            border: 1px solid #D9D9D9;
            border-radius: 50%;
            background-color: #FFF;
            cursor: pointer;

            &::after {
                content: "";
                @include position(absolute, 2, 50%, none, none, 50%);
                width: 6px;
                height: 6px;
                border-radius: 50%;
                background-color: #FFF;
                -webkit-transform: translate(-50%, -50%) scale(0);
                transform: translate(-50%, -50%) scale(0);
                -webkit-transition: -webkit-transform .15s cubic-bezier(.71, -.46, .88, .6);
                transition: transform .15s cubic-bezier(.71, -.46, .88, .6);
            }

            &.active {
                border-color: $themeColor;
                background: $themeColor;

                &::after {
                    -webkit-transform: translate(-50%, -50%) scale(1);
                    transform: translate(-50%, -50%) scale(1);
                }
            }
        }

        .radio-label {
            font-size: $smallFS;
            color: $textColor;
        }

        &.disabled{
            .radio-icon{
                cursor: not-allowed;
                opacity: .5;
            }
        }
    }

    .checkbox-item {
        position: relative;
        padding-left: 26px;

        .checkbox-icon {
            @include position(absolute, 1, 9px, none, none, 0);
            width: 14px;
            height: 14px;
            border: 1px solid #D9D9D9;
            border-radius: 2px;
            background-color: #FFF;
            cursor: pointer;
            -webkit-transition: border-color .25s cubic-bezier(.71,-.46,.29,1.46),background-color .25s cubic-bezier(.71,-.46,.29,1.46);
                    transition: border-color .25s cubic-bezier(.71,-.46,.29,1.46),background-color .25s cubic-bezier(.71,-.46,.29,1.46);

            &::after {
                content: "";
                @include position(absolute, 2, 1px, none, none, 4px);
                width: 3px;
                height: 7px;
                border: 1px solid #FFF;
                border-left: 0;
                border-top: 0;
                -webkit-transform: rotate(45deg) scaleY(0);
                        transform: rotate(45deg) scaleY(0);
                -webkit-transition: -webkit-transform .15s ease-in .05s;
                        transition:         transform .15s ease-in .05s;
                -webkit-transform-origin: center;
                        transform-origin: center;
            }

            &.active {
                border-color: $themeColor;
                background-color: $themeColor;

                &::after {
                    -webkit-transform: rotate(45deg) scaleY(1);
                            transform: rotate(45deg) scaleY(1);
                }
            }
        }

        .checkbox-label {
            font-size: $smallFS;
            color: $textColor;
        }

        &.disabled{
            .checkbox-icon{
                cursor: not-allowed;
                opacity: .5;
            }
        }
    }

</style>
